import { Inject, Injectable, DOCUMENT } from '@angular/core';


import { animate, AnimationBuilder, AnimationPlayer, style } from '@angular/animations';
import { Router } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class CoreLoadingScreenService {
	loadingScreenEl: any;
	animationPlayer: AnimationPlayer;

	/**
	 * Constructor
	 *
	 * @param _document
	 * @param {Router} _router
	 * @param {AnimationBuilder} _animationBuilder
	 */
	constructor(
		@Inject(DOCUMENT) private _document: any,
		private _router: Router,
		private _animationBuilder: AnimationBuilder
	) {
		// Initialize
		this._init();
	}

	// Private methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Initialize
	 *
	 * @private
	 */
	private _init(): void {
		// Get the loading screen element
		this.loadingScreenEl = this._document.body.querySelector('#loading-bg');

		// If loading screen element
		// if (this.loadingScreenEl) {
		// 	// Hide it on the first NavigationEnd event
		// 	this._router.events
		// 		.pipe(
		// 			filter(event => event instanceof NavigationEnd),
		// 			take(1)
		// 		)
		// 		.subscribe(() => {
		// 			setTimeout(() => {
		// 				this.hide();
		// 			});
		// 		});
		// }
	}

	// Public methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Show the loading screen
	 */
	show(): void {
		// Imposta z-index direttamente sull'elemento (non è animabile)
		if (this.loadingScreenEl) {
			this.loadingScreenEl.style.zIndex = '99999';
		}

		this.animationPlayer = this._animationBuilder
			.build([
				style({
					opacity: '0',
				}),
				animate('250ms ease', style({ opacity: '1' })),
			])
			.create(this.loadingScreenEl);

		setTimeout(() => {
			this.animationPlayer.play();
		}, 0);
	}

	/**
	 * Hide the loading screen
	 */
	hide(): void {
		this.animationPlayer = this._animationBuilder
			.build([
				style({ opacity: '1' }),
				animate(
					'250ms ease',
					style({
						opacity: '0',
					})
				),
			])
			.create(this.loadingScreenEl);

		setTimeout(() => {
			// Imposta z-index dopo l'animazione
			if (this.loadingScreenEl) {
				this.loadingScreenEl.style.zIndex = '-10';
			}
			this.animationPlayer.play();
		}, 0);

		// Rimuovi l'elemento dopo che l'animazione è completata
		this.animationPlayer.onDone(() => {
			if (this.loadingScreenEl) {
				this.loadingScreenEl.remove();
			}
		});
	}
}
